import React from 'react'
import Address from './SubTab/Address'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import GeneralAccInfo from './SubTab/GeneralAccInfo';
import GeneralBilling from './SubTab/GeneralBilling';
import BankDetails from './SubTab/BankDetails';
import TDS from './SubTab/TDS';
const AccountInfo = () => {
    const ApplicableOption = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];

    return (
        <>
            <div className="row border-bottom-2 pb-3">

                <div className="col-md-12">
                    <div className=" py-2">
                        <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3" >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                    <i className="ti ti-user-plus fs-20" />
                                </span>
                                    General </Accordion.Header>
                                <Accordion.Body>
                                    <GeneralAccInfo />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                        <Accordion className="accordion-item rounded mb-3" >
                            <Accordion.Item eventKey="1">
                                <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                    <i className="ti ti-user-plus fs-20" />
                                </span>
                                    TDS Details </Accordion.Header>
                                <Accordion.Body>
                                    <TDS />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                        <Accordion className="accordion-item rounded mb-3" >
                            <Accordion.Item eventKey="1">
                                <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                    <i className="ti ti-user-plus fs-20" />
                                </span>
                                    Bank Details </Accordion.Header>
                                <Accordion.Body>
                                    <BankDetails />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <Accordion className="accordion-item rounded mb-3" >
                            <Accordion.Item eventKey="1">
                                <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                    <i className="ti ti-user-plus fs-20" />
                                </span>
                                    Billing </Accordion.Header>
                                <Accordion.Body>
                                    <GeneralBilling />
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
            </div>

        </>
    )
}

export default AccountInfo